// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-sub-event{border-left:5px solid #f6f6f6;display:flex;margin-top:36px;padding:0 0 16px 16px;position:relative}.new-sub-event--inputs{flex:1}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
